import { NORMALIZED_STAGE } from 'src/constants/EnvironmentConstants';

/** StarGrid API base URL per stage (matches the ACM/Route 53 domains in StarGrid-ServiceCDK). */
const API_BASE_URL_BY_STAGE: Record<string, string> = {
  alpha: 'https://alpha.api.stargrid.device.finance.amazon.dev',
  beta: 'https://beta.api.stargrid.device.finance.amazon.dev',
  prod: 'https://api.stargrid.device.finance.amazon.dev'
};

/** Resolved StarGrid API base URL for the current stage (falls back to alpha for local dev). */
export const STAR_GRID_API_BASE_URL = API_BASE_URL_BY_STAGE[NORMALIZED_STAGE] ?? API_BASE_URL_BY_STAGE.alpha;

/** In-app route for the StarGrid feature. */
export const STAR_GRID_ROUTE = '/star-grid';

/** StarGrid sub-views, selected via the in-page side navigation.
 *  - `create-report` : the PnL report builder (persists a report via POST /pnl-reports).
 *  - `report`        : a single created PnL report's detail/pivot view (see activeReportId).
 */
export type StarGridView = 'home' | 'infra' | 'create-report' | 'report' | 'data-sync';

// ─── PnL cube system columns ──────────────────────────────────────────────────
// The materialized PnL cube stores each (scenario, month) fact as its own row.
// The serving layer (§6) returns a FLAT GROUP BY result; to render the xPT-style
// scenario × period pivot the FE requests these system columns in `group_by` and
// pivots long → wide client-side (see utils/pnlPivot.ts). These names MUST match
// the backend cube (`pnl_reports/constants.py`: CUBE_SCENARIO_COLUMN / CUBE_MONTH_COLUMN
// / CUBE_VALUE_COLUMN).
export const PNL_CUBE_SCENARIO_COLUMN = 'scenario_id';
export const PNL_CUBE_MONTH_COLUMN = 'month';
export const PNL_CUBE_VALUE_COLUMN = 'value';

/** Virtual dimension key for calculated P&L statement lines (Operating Income, etc.). */
export const PNL_STATEMENT_LINE_DIMENSION = 'pnl_statement_line';
